import React from 'react';

const KohlerLogo = /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "98", height: "22", viewBox: "0 0 98 22", fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.4246 21.0039V0.938011H58.8226V15.8755L64.8821 15.8759V21.0039H53.4246Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8363 21.0039V0.938011H41.2343V7.97396H46.6772V0.938011H52.0751V21.0039H46.6772V13.5395H41.2343V21.0039H35.8363Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4953 0.940677L9.69605 10.4966L18.6075 21.0111L11.4631 21.0073L5.40994 13.8491H5.39757L5.39794 21.0039H0V0.938011H5.39757V6.94837L5.35558 6.95332L10.4967 0.940677H17.4953Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7559 15.9475C27.2873 15.9475 29.3401 13.6431 29.3401 10.8005C29.3401 7.95796 27.2873 5.65352 24.7559 5.65352C22.2241 5.65352 20.1714 7.95796 20.1714 10.8005C20.1714 13.6431 22.2241 15.9475 24.7559 15.9475ZM14.5714 10.8043C14.5714 5.03086 19.1312 0.35 24.7559 0.35C30.3803 0.35 34.9401 5.03086 34.9401 10.8043C34.9401 16.5778 30.3803 21.2587 24.7559 21.2587C19.1312 21.2587 14.5714 16.5778 14.5714 10.8043Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.9492 0.938011V5.56098L71.5295 5.57317L71.51 8.7402H76.5169V13.2322H71.5175L71.5216 16.2945H76.996V21.0039H65.9913V0.938011H76.9492Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.0033 9.45236C86.0537 9.45236 86.9054 8.5871 86.9054 7.51962C86.9054 6.45214 86.0537 5.58688 85.0033 5.58688H83.4739V9.44741L85.0033 9.45236ZM88.1716 12.9854L93.7885 21.0149L87.8946 21.0043L83.4923 14.8439V20.9925H78.2034V0.930394H84.9704C90.9242 0.930394 94.7028 8.51931 88.1716 12.9854Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.4177 19.6858C96.6243 19.6858 96.7412 19.6401 96.7412 19.4025C96.7412 19.2105 96.5028 19.2105 96.3233 19.2105H95.9233V19.6858H96.4177ZM97.0741 20.7636H96.6243L96.2108 19.9688H95.9233V20.7636H95.5095V18.8819H96.4087C96.8357 18.8819 97.1277 18.9596 97.1277 19.4569C97.1277 19.8046 96.9527 19.9459 96.6243 19.9688L97.0741 20.7636ZM97.5775 19.8454C97.5775 19.0323 96.9841 18.4569 96.2198 18.4569C95.442 18.4569 94.8621 19.0323 94.8621 19.8454C94.8621 20.6493 95.442 21.2248 96.2198 21.2248C96.9841 21.2248 97.5775 20.6493 97.5775 19.8454ZM94.4396 19.8454C94.4396 18.8362 95.2261 18.0276 96.2198 18.0276C97.2091 18.0276 98 18.8362 98 19.8454C98 20.8458 97.2091 21.6543 96.2198 21.6543C95.2261 21.6543 94.4396 20.8458 94.4396 19.8454Z",
    fill: "currentColor"
  }
));

export { KohlerLogo };
